import getWindow from './getWindow.js';

function getComputedStyle(element) {
  return getWindow(element).getComputedStyle(element);
}

export { getComputedStyle as default };
